import { useQuery } from "@tanstack/react-query";
import { getComedianStripeStatus } from "../client/manager/stripe";

interface ComedianSubscriptionProductStatus {
  hasSubscriptionProduct: boolean;
  isLoading: boolean;
  refetch: () => Promise<unknown>;
}

export function useComedianHasSubscriptionProduct(
  comedianId: string
): ComedianSubscriptionProductStatus {
  const query = useQuery({
    queryKey: ["comedian", comedianId, "stripe-status"],
    queryFn: () => getComedianStripeStatus(comedianId),
    staleTime: 30_000,
  });

  return {
    hasSubscriptionProduct: query.data?.hasSubscriptionProduct ?? false,
    isLoading: query.isLoading,
    refetch: query.refetch,
  };
}
